{
  "search-result-for": "Sökträffar för \"{{searchStr}}\"",
  "Search results": "Sökträffar"
}
